import React, { useEffect, useState } from "react";
import { Paper, IconButton, Chip, Avatar, Tooltip } from "@mui/material";
import MUIDataTable from "../../../components/LegacyMuiDataTable";
import EditIcon from "@mui/icons-material/Edit";
import Visibility from "@mui/icons-material/Visibility";
import Delete from "@mui/icons-material/Delete";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useSelector, useDispatch } from "react-redux";
import { green } from "@mui/material/colors";
import { useSnackbar } from "notistack";
import { useHistory } from "react-router-dom";

import { getFilters, deleteFilter } from "../../../store/ducks/duckFilter";
import { getFilterValues } from "../../../store/ducks/duckFilterValue";
import { getLayouts } from "../../../store/ducks/duckLayout";
import { getByFilterId, getLayoutFilters } from "../../../store/ducks/duckLayoutFilter";
import { useStylesLayout } from "../../../styles/Layout";
import { BorderLinearProgress } from "../../../components/LoadingComponent";
import MaxChips from "../../../components/MaxChips";
import NavBar from "../../../components/Navbar";
import CustomToolbar from "../../../components/CustomToolbar";
import ConfirmDelete from "../../../components/confirmDelete";

import PreviewSelect from "./components/PreviewSelect";
import FilterForm from "./components/FilterForm";

const filterDefault = {
  id: 0,
  name: "",
  positionNumber: 1,
  parameter: "",
  stringToMatch: "",
  deleted: false,
};

const Filter = () => {
  const classes = useStylesLayout();
  const { enqueueSnackbar } = useSnackbar();
  const data = useSelector((state) => state.filter.data);
  const loading = useSelector((state) => state.filter.isLoading);

  const getFilterName = (id) => data.find((x) => x.id === id)?.name ?? "";

  const dataLayouts = useSelector((state) => {
    let data = state.layout.dataLayout;
    let dataL = {};

    data.forEach((x) => {
      dataL[x.id] = x.name;
    });

    return dataL;
  });

  const layoutsFilters = useSelector((state) => state.layoutFilter.data);

  const history = useHistory();

  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const [id, setId] = useState(0);
  const [name, setName] = useState("");
  const [isEdit, setEdit] = useState(false);
  // eslint-disable-next-line
  const [layouts, setLayouts] = useState([]);
  // eslint-disable-next-line
  const [type, setType] = useState(null);
  // eslint-disable-next-line
  const [positionNumber, setPositionNumber] = useState(null);
  // eslint-disable-next-line
  const [parameter, setParameter] = useState(null);
  // eslint-disable-next-line
  const [stringToMatch, setStringToMatch] = useState(null);
  // eslint-disable-next-line
  const [tag, setTag] = useState("");

  const [openPreview, setOpenPreview] = useState(false);
  const [filter, setFilter] = useState(filterDefault);

  const [openConfirm, setOpenConfirm] = useState(false);

  const [promiseSucess, setPromiseSucess] = useState();

  useEffect(() => {
    Promise.all([
      dispatch(getFilters()),
      dispatch(getLayouts()),
      dispatch(getLayoutFilters()),
      dispatch(getFilterValues()),
    ]).then(() => setPromiseSucess(true));
  }, [dispatch]);

  const handleClickReload = () => {
    dispatch(getFilters());
    dispatch(getLayouts());
    dispatch(getLayoutFilters());
    dispatch(getFilterValues());
  };

  const handleRedirect = (filterId) => (e) => {
    e.preventDefault();

    if (filterId) {
      history.push(`/Administration/FilterValue/${filterId}`);
    }
  };
  const handleClickOpen =
    (filter, isEdit = true) =>
    (event) => {
      event.preventDefault();
      setFilter(filter);
      setId(filter?.id || 0);
      setName(filter?.name || "");
      setEdit(isEdit);
      setPositionNumber(filter?.positionNumber || 1);
      setParameter(filter?.parameter || "");
      setStringToMatch(filter?.stringToMatch);
      if (filter?.id) {
        //dispatch(getByFilterId(filter.id));
      }

      setLayouts(filter?.layouts || []);
      setType(filter?.type || "");

      setOpen(true);
    };

  const handleClosePreview = () => {
    setOpenPreview(false);
  };
  const handleClickPreview = (filter) => (event) => {
    event.preventDefault();

    setFilter(filter);

    setOpenPreview(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handleConfirm = (filter) => (event) => {
    event.preventDefault();
    setId(filter?.id);
    setName(filter?.name);
    setFilter(filter?.type);
    setPositionNumber(filter?.positionNumber);
    setParameter(filter?.parameter);
    setLayouts(filter?.layouts || []);
    setStringToMatch(filter?.stringToMatch);
    setTag(filter?.tag);

    setOpenConfirm(true);
  };

  const handleDelete = (event) => {
    event.preventDefault();
    dispatch(deleteFilter(id)).then(() =>
      enqueueSnackbar(`Filter ${name} Deleted succesfully`, { variant: "info" }),
    );
    handleCloseConfirm();
  };

  const columns = [
    {
      name: "id",
      label: "Id",
      options: {
        filter: true,
        display: false,
        customFilterListOptions: {
          render: (v) => getFilterName(v),
        },
        filterOptions: {
          renderValue: (v) => getFilterName(v),
        },
      },
    },
    {
      name: "deleted",
      label: "Deleted",
      options: {
        filter: true,
        display: false,
        filterType: "dropdown",
        customFilterListOptions: { render: (v) => `Deleted: ${v}` },
        filterList: [false],
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        filter: true,
      },
    },
    {
      label: "Layouts",
      name: "layouts",
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          let filterId = data[dataIndex]?.id;
          let layoutsId = layoutsFilters
            .filter((x) => x.filterId === filterId)
            .map((x) => x.layoutId);
          const unique = [...new Set(layoutsId)];

          return (
            <MaxChips maxChips={3}>
              {unique &&
                unique.map((id, i) => {
                  let layout = dataLayouts[id];

                  return (
                    <Tooltip key={`tooltip-layout-${filterId}-${id}-${i}`} title={`${layout}`}>
                      <Chip
                        key={`layouts-${filterId}-${id}-${i}`}
                        avatar={
                          <Avatar
                            style={{
                              color: green[700],
                              backgroundColor: green[300],
                            }}
                          >
                            {layout && layout.slice(0, 1)}
                          </Avatar>
                        }
                        label={layout && layout.slice(0, 1)}
                        size="small"
                        style={{
                          color: green[700],
                          borderColor: green[300],
                          margin: 3,
                        }}
                        variant="outlined"
                      />
                    </Tooltip>
                  );
                })}
            </MaxChips>
          );
        },
      },
    },
    {
      name: "type",
      label: "Type",
      options: {
        filter: true,
      },
    },
    {
      name: "parameter",
      label: "Parameter: String to Match",
      options: {
        filter: true,
        customBodyRenderLite: (dataIndex) => {
          const { parameter, stringToMatch, type } = data[dataIndex];
          let isCustom = type.toLowerCase() !== "normal";
          let label = parameter ? `${parameter}: ${stringToMatch}` : `${stringToMatch}`;

          return (
            <>
              {isCustom ? (
                <Chip
                  className={classes.chipLayouts}
                  label={`${label}`}
                  size="small"
                  variant="outlined"
                />
              ) : (
                <Chip
                  className={classes.chipLayouts}
                  label={`${parameter}`}
                  size="small"
                  variant="outlined"
                />
              )}
            </>
          );
        },
        customFilterListOptions: {
          render: (v) => v ?? "None",
        },
        filterOptions: {
          renderValue: (v) => v ?? "None",
        },
      },
    },
    {
      name: "positionNumber",
      label: "Position",
      options: {
        filter: true,
      },
    },
    {
      name: "tag",
      label: "Tag",
      options: {
        filter: true,
        customFilterListOptions: {
          render: (v) => v ?? "None",
        },
        filterOptions: {
          renderValue: (v) => v ?? "None",
        },
      },
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        empty: true,
        viewColumns: false,
        customBodyRenderLite: (dataIndex) => {
          let rowData = data[dataIndex];

          if (promiseSucess) {
            return (
              <div style={{ maxWidth: 250 }}>
                <Tooltip title={"Edit"}>
                  <IconButton
                    aria-label="edit"
                    size="small"
                    onClick={handleClickOpen(rowData, true)}
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title={"Preview"}>
                  <IconButton
                    aria-label="Preview"
                    size="small"
                    onClick={handleClickPreview(rowData)}
                  >
                    <Visibility />
                  </IconButton>
                </Tooltip>
                <Tooltip title={rowData.deleted ? "Is already removed" : "Delete"}>
                  <IconButton
                    aria-label="delete"
                    disabled={rowData.deleted}
                    size="small"
                    onClick={handleConfirm(rowData)}
                  >
                    <Delete />
                  </IconButton>
                </Tooltip>
                <Tooltip title={"Edit FilterValues"}>
                  <IconButton
                    aria-label="open"
                    disabled={rowData.deleted}
                    size="small"
                    onClick={handleRedirect(rowData.id)}
                  >
                    <OpenInNewIcon />
                  </IconButton>
                </Tooltip>
              </div>
            );
          }
        },
        setCellProps: () => ({ style: { width: 170, textAlign: "right" } }),
      },
    },
  ];

  const options = {
    filterType: "multiselect",
    // expandableRows: true,
    expandableRowsOnClick: false,
    selectableRows: "none",
    download: false,
    print: false,
    viewColumns: true,
    customToolbar: () => {
      return (
        <CustomToolbar
          handleClick={handleClickOpen(filterDefault)}
          handleReload={handleClickReload}
        />
      );
    },
    //Dense
    setTableProps: () => {
      return {
        padding: "default",
        size: "small",
      };
    },
    setRowProps: (row, dataIndex, _rowIndex) => {
      let deleted = data[dataIndex]?.deleted;

      return (
        deleted && {
          style: { backgroundColor: "Gainsboro" },
          title: "Deleted",
        }
      );
    },
    textLabels: {
      body: {
        noMatch: loading ? "loading..." : "Sorry, no matching records found",
      },
    },
    responsive: "standard",
    fixedHeader: true,
    fixedSelectColumn: false,
    tableBodyHeight: "420px",
    jumpToPage: true,
  };

  return (
    <>
      <NavBar />
      <Paper className={classes.administrationPaper}>
        {loading && <BorderLinearProgress />}
        {filter && (
          <PreviewSelect filter={filter} handleClose={handleClosePreview} open={openPreview} />
        )}
        <ConfirmDelete
          handleClose={handleCloseConfirm}
          handleDelete={handleDelete}
          message={`Are you sure to Delete the Filter with Name: ${name}?`}
          open={openConfirm}
        />
        {open && filter && (
          <FilterForm
            handleClose={handleClose}
            initialValues={filter}
            isEdit={isEdit}
            open={open}
          />
        )}
        <MUIDataTable columns={columns} data={data} options={options} title={"Filters"} />
      </Paper>
    </>
  );
};

export default Filter;
